import { render } from "./CardioQnrPage.vue?vue&type=template&id=6a1f11f0"
import script from "./CardioQnrPage.vue?vue&type=script&lang=js"
export * from "./CardioQnrPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__